module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageView"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0835e82e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/modules/back-main.vue
// module id = 561
// module chunks = 221